import React, { ReactElement, useState } from "react";

import { Wrapper, ImageContainer, InfoContainer, Title, Value, Caption } from "./style";

export interface ImageGridItemProps {
  image: ReactElement;
  title?: string;
  value?: string;
  caption?: string;
  className?: string;
  external_link?: string;
  open_in_new_window?: boolean;
}

const ImageGridItem: React.FC<ImageGridItemProps> = ({ image, title, value, caption, className }) => {
  const [dimensions, setDimensions] = useState<[number, number]>();
  image = React.cloneElement(image, {
    onLoad: (e: any) => {
      if (!(e instanceof Image)) return;
      setDimensions([e.naturalWidth, e.naturalHeight]);
    },
  });

  return (
    <Wrapper className={className}>
      <ImageContainer dimensions={dimensions}>{image}</ImageContainer>
      {title || value || caption ? (
        <InfoContainer>
          {title ? <Title>{title}</Title> : null}
          {value ? <Value>{value}</Value> : null}
          {caption ? <Caption>{caption}</Caption> : null}
        </InfoContainer>
      ) : null}
    </Wrapper>
  );
};

export default ImageGridItem;
